if(!customElements.get('image-magnify')) {
  customElements.define('image-magnify', class ImageMagnify extends HTMLElement {
    constructor() {
      super();

      this.image = this.querySelector('img');
      this.scaleRatio = parseFloat(this.getAttribute('data-scale')) || 1.5;
      this.boundHandleImageMove = this.handleImageMove.bind(this);
      this.enableMove = false;

      // 添加鼠标事件监听器
      this.addEventListener('mousedown', this.enableZoom.bind(this), {passive: true});
      this.addEventListener('mouseup', this.disableZoom.bind(this));
      this.addEventListener('mouseleave', this.disableZoom.bind(this));

      // 添加触摸事件监听器
      this.addEventListener('touchstart', this.enableZoom.bind(this), {passive: true});
      this.addEventListener('touchend', this.disableZoom.bind(this));
      this.addEventListener('touchcancel', this.disableZoom.bind(this));
    }

    enableZoom(event) {
      // event.preventDefault();
      event.stopPropagation();

      this.classList.add('image-zoom-in');
      this.enableMove = true;
      this.image.style.transformOrigin = 'center';
      this.image.style.transition = 'scale 300ms ease';
      this.image.style.scale = this.scaleRatio;

      this.rect = this.getBoundingClientRect();
      this.centerPos = [
        (this.rect.right - this.rect.left) / 2,
        (this.rect.bottom - this.rect.top) / 2
      ];

      // 等待Scale动画完成后
      setTimeout(() => {
        this.imageRect = this.image.getBoundingClientRect();

        this.maxTransX = this.imageRect.left < this.rect.left
          ? this.rect.left - this.imageRect.left
          : 0;

        this.maxTransY = this.imageRect.top < this.rect.top
          ? this.rect.top - this.imageRect.top
          : 0;

        // 添加移动事件监听器
        this.addEventListener('mousemove', this.boundHandleImageMove, {passive: true});
        this.addEventListener('touchmove', this.boundHandleImageMove, {passive: true});
      }, 300);
    }

    disableZoom() {
      this.enableMove = false;
      this.classList.remove('image-zoom-in');

      this.image.removeAttribute('style');
      // 移除移动事件监听器
      this.removeEventListener('mousemove', this.boundHandleImageMove);
      this.removeEventListener('touchmove', this.boundHandleImageMove);
    }

    handleImageMove(event) {
      if (!this.enableMove) return;
      event.stopPropagation();
      // event.preventDefault();

      let clientX, clientY;

      // 判断事件类型以获取正确的坐标
      if (event.type.startsWith('touch')) {
        const touch = event.touches[0] || event.changedTouches[0];
        clientX = touch.clientX;
        clientY = touch.clientY;
      } else {
        clientX = event.clientX;
        clientY = event.clientY;
      }

      this.currentPos = [clientX, clientY];
      let transX = 0;
      let transY = 0;

      if (this.maxTransX > 0) {
        transX = this.centerPos[0] - clientX;
      }

        if (this.maxTransY > 0) {
            transY = this.centerPos[1] - clientY;
            transY = Math.sign(transY) * Math.min(Math.abs(transY), this.maxTransY) / this.scaleRatio;
        }

        this.image.style.transform = `translate(${transX}px, ${transY}px)`;
    }
  });
}